const fromdata = [{
		inputdata: "",
		title: "关系标识",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	}, {
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		pt: true,
		width: "310px",
		lablewith: "110px",
		btx: false,
		options: [],
	}, {
		inputdata: "",
		title: "公司负责人",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "补充经销商",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectautocompletemultiple",
		pt: true,
		width: "310px",
		btx: false,
		lablewith: "110px",
		options: [],
	},
];
export default fromdata;